import { useCreateCampaign, useInvalidateAggregatedPostStats } from '@round/creatorbase-helpers/api-hooks';
import useInvalidateProjectCampaignContext from './useInvalidateProjectCampaignContext';

// useCreateCampaign invalidates every campaign query (keys.all) on success, which is broader
// than this project. Acceptable for now — observed queries off this project just get marked
// stale and only refetch when next visited.
export default function useCreateProjectCampaign() {
    const invalidateProjectCampaignContext = useInvalidateProjectCampaignContext();
    const invalidateAggregatedPostStats = useInvalidateAggregatedPostStats();

    return useCreateCampaign({
        onSuccess: (campaign) => {
            invalidateProjectCampaignContext({
                project_id: campaign.project_id,
                platform: campaign.platform,
            });
            invalidateAggregatedPostStats({ campaign_id: campaign.id }).catch(() => {});
        },
    });
}
